import { TableCell } from '@carbon/react';
import classnames from 'classnames';
import { LineItemValueCellProps } from 'pages/development-areas/show/allocation-manager-types';
import TooltipDecimal from 'components/tooltip-decimal/tooltip-decimal';
import styles from '../allocation-manager.module.scss';
import { warningColors } from '../constants/warningColors';

export const LineItemValueCell = ({
  value,
  isPercentage = false,
  warnings = [],
  warningIds = [],
  className,
}: LineItemValueCellProps) => {
  const content =
    value !== undefined && value !== null ? (
      <TooltipDecimal value={value} isPercentage={isPercentage} />
    ) : (
      ''
    );

  // Get the last applicable warning for this cell
  const applicableWarnings = warnings.filter((warning) =>
    warningIds.includes(warning)
  );
  const lastWarning = applicableWarnings[applicableWarnings.length - 1];
  const warningColor = lastWarning
    ? warningColors[lastWarning as keyof typeof warningColors]
    : undefined;

  return (
    <TableCell
      className={classnames(styles.valueCell, className)}
      style={warningColor ? { backgroundColor: warningColor } : undefined}
    >
      {content}
    </TableCell>
  );
};
